import type { FetcherAxiosInstance } from '../fetcher';

export const createPersEventApi = (Fetcher: FetcherAxiosInstance) => ({
  sendHeaderPersEvent({ type, header }) {
    return Fetcher.post(`/${type}/_sendHeader`, { header }, { baseURL: '/events-api/v1' });
  },

  sendBasePersEvent({ type, data }) {
    return Fetcher.post(`/${type}/_send`, data, { baseURL: '/events-api/v1' });
  },

  sendPersEvent({ type, data }) {
    return Fetcher.post(`/${type}`, data, { baseURL: '/events-api/v1' });
  },
});
